import { Box } from "@mui/material";
import MyCommunityCard from "../../../Components/MyCommunityCard";
import CommunityHeader from "./CommunityHeader";

const ContentBody = (props) => {
  const {
    isLoading,
    activeMembersData,
    joinRequestsData,
    waitApprovalData,
    openModal,
    sortOrder,
    toggleSortOrder,
    activeTab,
    setActiveTab,
    activateCommunity,
    setContainerRef,
    communityMemberStats,
  } = props;

  return (
    <>
      <CommunityHeader
        {...{
          activeTab,
          setActiveTab,
          communityMemberStats,
        }}
      />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          flexBasis: 1,
          overflow: "hidden",
        }}
      >
        {activeTab === 1 && (
          <MyCommunityCard
            data={activeMembersData}
            openModal={openModal}
            activeTab={activeTab}
            sortOrder={sortOrder}
            toggleSortOrder={toggleSortOrder}
            isLoading={isLoading}
            activateCommunity={activateCommunity}
            containerRef={setContainerRef}
            communityMemberStats={communityMemberStats}
          />
        )}
        {activeTab === 2 && (
          <MyCommunityCard
            data={joinRequestsData}
            openModal={openModal}
            activeTab={activeTab}
            sortOrder={sortOrder}
            toggleSortOrder={toggleSortOrder}
            isLoading={isLoading}
            containerRef={setContainerRef}
            communityMemberStats={communityMemberStats}
          />
        )}
        {activeTab === 3 && (
          <MyCommunityCard
            data={waitApprovalData}
            openModal={openModal}
            activeTab={activeTab}
            sortOrder={sortOrder}
            toggleSortOrder={toggleSortOrder}
            isLoading={isLoading}
            containerRef={setContainerRef}
            communityMemberStats={communityMemberStats}
          />
        )}
      </Box>
    </>
  );
};

export default ContentBody;
